import { Injectable } from '@angular/core';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {Airport} from '../interfaces/Airport';
import {AirportService} from '../services/airport/airport.service';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class AirportResolverService extends BreadCrumbAndDataResolverService<Airport> {

    constructor(private airportService: AirportService, helper: BreadCrumbAndDataHelperService) {
        super(helper);
    }

    public async getData(route: ActivatedRouteSnapshot): Promise<Airport> {
        return await this.airportService.getAirport(Number(route.params.airportId));
    }

    public getName(data: Airport): string {
        return data.name;
    }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airport/resolvers/airport-resolver.service.ts